import { datatypes, inputTypes } from "data/globalData";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";

export const tableColumns = {
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	price: {
		name: "Price",
		key: "price",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};
export const tableRowTypes = {
	modal_cost: {
		name: "Modal",
		key: "modal_cost",
		// value_type: "percent",
	},
	mua_price: {
		name: "MUA Price",
		key: "mua_price",
		// value_type: "percent",
	},
	ai_cost: {
		name: "AI",
		key: "ai_cost",
		// value_type: "percent",
	},
	food_cost: { name: "Food ", key: "food_cost" },
	hotel_cost: { name: "Hotel ", key: "hotel_cost" },
	flight_cost: { name: "Flight ", key: "flight_cost" },
	cab_cost: { name: "Cab ", key: "cab_cost" },
};

export const defaultTableData = [
	{
		id: 1,
		category: tableRowTypes.modal_cost.key,
		price: 0,
		value: 0,
	},
	{
		id: 2,
		category: tableRowTypes.mua_price.key,
		price: 0,
		value: 0,
	},
	{
		id: 3,
		category: tableRowTypes.ai_cost.key,
		price: 0,
		value: 0,
	},
	{
		id: 4,
		category: tableRowTypes.food_cost.key,
		price: 0,
		value: 0,
	},
	{
		id: 5,
		category: tableRowTypes.hotel_cost.key,
		price: 0,
		value: 0,
	},
	{
		id: 6,
		category: tableRowTypes.flight_cost.key,
		price: 0,
		value: 0,
	},
	{
		id: 7,
		category: tableRowTypes.cab_cost.key,
		price: 0,
		value: 0,
	},
];
export const defaultTotalRow = {
	id: "TOTAL",
	category: "TOTAL",
	price: null,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row.trims_id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	// let price = 0;
	let value = 0;
	allRows?.forEach((row) => {
		// if (!isNaN(row?.[tableColumns.price.key])) price += +row?.[tableColumns.price.key];
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	console.log("dsmnfbdskfbksd", allRows, value);

	return {
		...defaultTotalRow,
		//  [tableColumns.price.key]: price,
		[tableColumns.value.key]: value,
	};
};

export const calculateMarginPlusOhValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(((Number(row?.price) ?? 0) / 100) * garmentTotal);
};
export const calculateWastagePercentValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(((Number(row?.price) ?? 0) / 100) * garmentTotal);
};
export const calculateTansportChargesValue = (row, garmentTotal = 0) => {
	return roundDecimalValueUptoTwoDigit(Number(row?.price) ?? 0);
};
export const calculateGptValue = (row, totalByQty = 0) => {
	if (!totalByQty) return 0;
	return roundDecimalValueUptoTwoDigit((Number(row?.price) ?? 0) / totalByQty ?? 0);
};
